import utils from '../../../utils/utils';
/*eslint-disable*/

export default function getDefaultBlockInfo(type) {
  console.log('type:: ', type);
  switch (type) {
    case 'html-html-html':
      return {
        _id: utils.getNewObjectId(),
        type: 'html',
        items: [
          {
            _id: utils.getNewObjectId(),
            html:
              "<h2>Insert text here</h2><p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
          }
        ],
        family: 'html',
        variant: 'html',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'text-text-paragraph':
      return {
        _id: utils.getNewObjectId(),
        type: 'text',
        items: [
          {
            _id: utils.getNewObjectId(),
            paragraph:
              "<p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
          }
        ],
        family: 'text',
        variant: 'paragraph',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'text-text-headingParagraph':
      return {
        _id: utils.getNewObjectId(),
        type: 'text',
        items: [
          {
            _id: utils.getNewObjectId(),
            heading: 'Heading',
            paragraph:
              "<p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
          }
        ],
        family: 'text',
        variant: 'headingParagraph',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'text-text-subheadingParagraph':
      return {
        _id: utils.getNewObjectId(),
        type: 'text',
        items: [
          {
            _id: utils.getNewObjectId(),
            heading: 'Subheading',
            paragraph:
              "<p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
          }
        ],
        family: 'text',
        variant: 'subheadingParagraph',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'text-text-heading':
      return {
        _id: utils.getNewObjectId(),
        type: 'text',
        items: [
          {
            _id: utils.getNewObjectId(),
            heading: 'Heading'
          }
        ],
        family: 'text',
        variant: 'heading',
        settings: {
          paddingTop: 3,
          paddingBottom: 0,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'text-text-subheading':
      return {
        _id: utils.getNewObjectId(),
        type: 'text',
        items: [
          {
            _id: utils.getNewObjectId(),
            heading: 'Subheading'
          }
        ],
        family: 'text',
        variant: 'subheading',
        settings: {
          paddingTop: 3,
          paddingBottom: 0,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'text-text-twoColumn':
      return {
        _id: utils.getNewObjectId(),
        type: 'text',
        items: [
          {
            _id: utils.getNewObjectId(),
            paragraph:
              '<p>A drop in the ocean partakes of the greatness of its parent, although it is unconscious of it. But it is dried up as soon as it enters upon an existence independent of the ocean. We do not exaggerate when we say that life is a mere bubble.</p>'
          },
          {
            _id: utils.getNewObjectId(),
            paragraph:
              '<p>A drop in the ocean partakes of the greatness of its parent, although it is unconscious of it. But it is dried up as soon as it enters upon an existence independent of the ocean. We do not exaggerate when we say that life is a mere bubble.</p>'
          }
        ],
        family: 'text',
        variant: 'twoColumn',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };

    case 'quote-quote-quoteA':
      return {
        _id: utils.getNewObjectId(),
        type: 'quote',
        items: [
          {
            _id: utils.getNewObjectId(),
            name: '<p>Mahatma Gandhi</p>',
            avatar: {
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/avatar.jpg',
                  src: 'avatar.jpg',
                  thumbnail: window.constants.imageUrl + 'blocks1/gandhiji.png',
                  originalUrl: 'avatar.jpg'
                }
              }
            },
            paragraph:
              '<p>Service which is rendered without joy helps neither the servant nor the served. But all other pleasures and possessions pale into nothingness before service which is rendered in a spirit of joy.</p>'
          }
        ],
        family: 'quote',
        variant: 'a',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'quote-quote-quoteB':
      return {
        _id: utils.getNewObjectId(),
        type: 'quote',
        items: [
          {
            _id: utils.getNewObjectId(),
            name: '<p>Mahatma Gandhi</p>',
            avatar: {
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/avatar.jpg',
                  src: 'avatar.jpg',
                  thumbnail: window.constants.imageUrl + 'blocks1/gandhiji.png',
                  originalUrl: 'avatar.jpg'
                }
              }
            },
            paragraph:
              '<p>Service which is rendered without joy helps neither the servant nor the served. But all other pleasures and possessions pale into nothingness before service which is rendered in a spirit of joy.</p>'
          }
        ],
        family: 'quote',
        variant: 'b',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'quote-quote-quoteC':
      return {
        _id: utils.getNewObjectId(),
        type: 'quote',
        items: [
          {
            _id: utils.getNewObjectId(),
            name: '<p>Mahatma Gandhi</p>',
            avatar: {
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/avatar.jpg',
                  src: 'avatar.jpg',
                  thumbnail: window.constants.imageUrl + 'blocks1/gandhiji.png',
                  originalUrl: 'avatar.jpg'
                }
              }
            },
            paragraph:
              '<p>Service which is rendered without joy helps neither the servant nor the served. But all other pleasures and possessions pale into nothingness before service which is rendered in a spirit of joy.</p>'
          }
        ],
        family: 'quote',
        variant: 'c',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'quote-quote-quoteD':
      return {
        _id: utils.getNewObjectId(),
        type: 'quote',
        items: [
          {
            _id: utils.getNewObjectId(),
            name: '<p>Mahatma Gandhi</p>',
            avatar: {
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/avatar.jpg',
                  src: 'avatar.jpg',
                  thumbnail: window.constants.imageUrl + 'blocks1/gandhiji.png',
                  originalUrl: 'avatar.jpg'
                }
              }
            },
            paragraph:
              '<p>Service which is rendered without joy helps neither the servant nor the served. But all other pleasures and possessions pale into nothingness before service which is rendered in a spirit of joy.</p>'
          }
        ],
        family: 'quote',
        variant: 'quoteD',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'quote-quote-quoteBackground':
      return {
        _id: utils.getNewObjectId(),
        type: 'quote',
        items: [
          {
            _id: utils.getNewObjectId(),
            name: '<p>Mahatma Gandhi</p>',
            avatar: {
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/avatar.jpg',
                  src: 'avatar.jpg',
                  thumbnail: window.constants.imageUrl + 'blocks1/gandhiji.png',
                  originalUrl: 'avatar.jpg'
                }
              }
            },
            paragraph:
              '<p>Service which is rendered without joy helps neither the servant nor the served. But all other pleasures and possessions pale into nothingness before service which is rendered in a spirit of joy.</p>',
            background: {
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/quote_background.jpg',
                  src: window.constants.imageUrl + 'blocks1/quote_background_image.jpg',
                  thumbnail: window.constants.imageUrl + 'blocks1/quote_background_image.jpg',
                  originalUrl: 'quote_background.jpg'
                }
              }
            }
          }
        ],
        family: 'quote',
        variant: 'fullBackground',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };

    case 'impact-impact-impactA':
      return {
        _id: utils.getNewObjectId(),
        type: 'impact',
        items: [
          {
            _id: utils.getNewObjectId(),
            paragraph:
              '<p>Service which is rendered without joy helps neither the servant nor the served. But all other pleasures and possessions pale into nothingness before service which is rendered in a spirit of joy.</p>'
          }
        ],
        family: 'impact',
        variant: 'a',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'impact-impact-impactB':
      return {
        _id: utils.getNewObjectId(),
        type: 'impact',
        items: [
          {
            _id: utils.getNewObjectId(),
            paragraph:
              '<p>Service which is rendered without joy helps neither the servant nor the served. But all other pleasures and possessions pale into nothingness before service which is rendered in a spirit of joy.</p>'
          }
        ],
        family: 'impact',
        variant: 'b',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'impact-impact-impactC':
      return {
        _id: utils.getNewObjectId(),
        type: 'impact',
        items: [
          {
            _id: utils.getNewObjectId(),
            paragraph:
              '<p><b>Service</b> which is rendered without joy helps neither the servant nor the <b>served</b>. But all other <b>pleasures</b> and possessions pale into nothingness before service which is rendered in a <b>spirit of joy</b>.</p>'
          }
        ],
        family: 'impact',
        variant: 'fullCImpact',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'impact-impact-impactD':
      return {
        _id: utils.getNewObjectId(),
        type: 'impact',
        items: [
          {
            _id: utils.getNewObjectId(),
            paragraph:
              '<p>Service which is rendered without joy helps neither the servant nor the served. But all other pleasures and possessions pale into nothingness before service which is rendered in a spirit of joy.</p>'
          }
        ],
        family: 'impact',
        variant: 'fullDImpact',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };

    case 'list-list-numbered':
      return {
        _id: utils.getNewObjectId(),
        type: 'list',
        items: [
          {
            _id: utils.getNewObjectId(),
            number: 1,
            paragraph: '<p>Always do your best. What you plant now, you will harvest later.</p>'
          },
          {
            _id: utils.getNewObjectId(),
            number: 2,
            paragraph:
              '<p>You are not here merely to make a living. You are here in order to enable the world to live more amply, with greater vision, with a finer spirit of hope and achievement. You are here to enrich the world, and you impoverish yourself if you forget the errand.</p>'
          },
          {
            _id: utils.getNewObjectId(),
            number: 3,
            paragraph:
              '<p>There is no passion to be found playing small - in settling for a life that is less than the one you are capable of living.</p>'
          }
        ],
        family: 'list',
        variant: 'numbered',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'list-list-bulleted':
      return {
        _id: utils.getNewObjectId(),
        type: 'list',
        items: [
          {
            _id: utils.getNewObjectId(),
            number: 1,
            paragraph: '<p>Always do your best. What you plant now, you will harvest later.</p>'
          },
          {
            _id: utils.getNewObjectId(),
            number: 2,
            paragraph:
              '<p>You are not here merely to make a living. You are here in order to enable the world to live more amply, with greater vision, with a finer spirit of hope and achievement. You are here to enrich the world, and you impoverish yourself if you forget the errand.</p>'
          },
          {
            _id: utils.getNewObjectId(),
            number: 3,
            paragraph:
              '<p>There is no passion to be found playing small - in settling for a life that is less than the one you are capable of living.</p>'
          }
        ],
        family: 'list',
        variant: 'bulleted',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };

    case 'image-image-hero':
      return {
        _id: utils.getNewObjectId(),
        type: 'image',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              image: {
                src: window.constants.imageUrl + 'sample_image_file.jpg',
                placeHolder:
                  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAA/ElEQVQYVwXBvSuEcQDA8e/Pc89dPSdPdKU7d/JMjxtQGCQTg/EWKauuDC4ZLIrJgMRAZolN3cCmlP/gJiV0d88iL8PzUM+L5+3n8xHWa0u2XtrI0COTy2JWhnhoe7ixguPH+EHE8kQR0T88Lq8vDynrOX7THk6bzxhGlZVJlYObJ2pTRdbWG4jS2JxMopSFpVUKZYPFisPZ7Rv12Qx7j3k+7o/wFQ0xMl2Tf5GPIkMaWxt0rQ5fssTd8SY79XlOmh0Cz0YMmjOyV9dJ45A+VUVkVbqWRQLk8wN4rotZsBEX59syQEPXBN+f75jVUXwvYXf/Cp+Yn1QjdWz+AZ+eYiHTnNK/AAAAAElFTkSuQmCC',
                thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                size: 100
              }
            },
            caption: '',
            paragraph: ''
          }
        ],
        family: 'image',
        variant: 'hero',
        settings: {
          opacity: 0.2,
          paddingTop: 3,
          zoomOnClick: true,
          opacityColor: '#000000',
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'image-image-full':
      return {
        _id: utils.getNewObjectId(),
        type: 'image',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              image: {
                src: window.constants.imageUrl + 'sample_image_file.jpg',
                placeHolder:
                  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAA/ElEQVQYVwXBvSuEcQDA8e/Pc89dPSdPdKU7d/JMjxtQGCQTg/EWKauuDC4ZLIrJgMRAZolN3cCmlP/gJiV0d88iL8PzUM+L5+3n8xHWa0u2XtrI0COTy2JWhnhoe7ixguPH+EHE8kQR0T88Lq8vDynrOX7THk6bzxhGlZVJlYObJ2pTRdbWG4jS2JxMopSFpVUKZYPFisPZ7Rv12Qx7j3k+7o/wFQ0xMl2Tf5GPIkMaWxt0rQ5fssTd8SY79XlOmh0Cz0YMmjOyV9dJ45A+VUVkVbqWRQLk8wN4rotZsBEX59syQEPXBN+f75jVUXwvYXf/Cp+Yn1QjdWz+AZ+eYiHTnNK/AAAAAElFTkSuQmCC',
                thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                size: 100
              }
            },
            caption: ''
          }
        ],
        family: 'image',
        variant: 'full',
        settings: {
          opacity: 0.2,
          paddingTop: 3,
          zoomOnClick: true,
          opacityColor: '#000000',
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'image-image-textAsideLeft':
      return {
        _id: utils.getNewObjectId(),
        type: 'image',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              image: {
                src: window.constants.imageUrl + 'left_right_image.jpg',
                placeHolder:
                  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAABBklEQVQoUwXBPUvDQACA4fdyl1yv6Ye1WihCQVAcFBEcBGcnUfAP+CPcXPwXzqKTu5MIVnBz7aZQ/KpQSWs1ado01ZzPI46bLfsbxgyVwpEuntagHCZpSrf9gq7MwDhGnNw82EZ9jsf3b8I/SyGnybuSXrfPV/jDOOjR7nwgDs+vrTRFPNdjPBrxNoiYLRvc6R/DMCJNUvqDHiJfrVmsRWbgL1YwccjC3hGty1OyJEJZRSYFwvh56yDIrTU4WF3h7OIK6WoUAk8bBLCxuYUoVOYtSNZ3tnlq3lPe3Se6u6Vc9QmeA6rLSwSdV4QxJWv9Iq7NyKYppXqNuPtJOkkQjsLRHlky4h/3hmZfc8P/ggAAAABJRU5ErkJggg==',
                thumbnail: window.constants.imageUrl + 'left_right_image.jpg',
                size: 100
              }
            },
            caption: '',
            paragraph:
              '<p><b>The Awakening </b></p><p>A drop in the ocean partakes of the greatness of its parent, although it is unconscious of it. But it is dried up as soon as it enters upon an existence independent of the ocean. We do not exaggerate when we say that life is a mere bubble.</p>'
          }
        ],
        family: 'image',
        variant: 'textAsideLeft',
        settings: {
          opacity: 0.2,
          paddingTop: 3,
          zoomOnClick: true,
          opacityColor: '#000000',
          imagePosition: 'left',
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'image-image-textAsideRight':
      return {
        _id: utils.getNewObjectId(),
        type: 'image',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              image: {
                src: window.constants.imageUrl + 'left_right_image.jpg',
                placeHolder:
                  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAABBklEQVQoUwXBPUvDQACA4fdyl1yv6Ye1WihCQVAcFBEcBGcnUfAP+CPcXPwXzqKTu5MIVnBz7aZQ/KpQSWs1ado01ZzPI46bLfsbxgyVwpEuntagHCZpSrf9gq7MwDhGnNw82EZ9jsf3b8I/SyGnybuSXrfPV/jDOOjR7nwgDs+vrTRFPNdjPBrxNoiYLRvc6R/DMCJNUvqDHiJfrVmsRWbgL1YwccjC3hGty1OyJEJZRSYFwvh56yDIrTU4WF3h7OIK6WoUAk8bBLCxuYUoVOYtSNZ3tnlq3lPe3Se6u6Vc9QmeA6rLSwSdV4QxJWv9Iq7NyKYppXqNuPtJOkkQjsLRHlky4h/3hmZfc8P/ggAAAABJRU5ErkJggg==',
                thumbnail: window.constants.imageUrl + 'left_right_image.jpg',
                size: 100
              }
            },
            caption: '',
            paragraph:
              '<p><b>The Awakening </b></p><p>A drop in the ocean partakes of the greatness of its parent, although it is unconscious of it. But it is dried up as soon as it enters upon an existence independent of the ocean. We do not exaggerate when we say that life is a mere bubble.</p>'
          }
        ],
        family: 'image',
        variant: 'textAsideRight',
        settings: {
          opacity: 0.2,
          paddingTop: 3,
          zoomOnClick: true,
          opacityColor: '#000000',
          imagePosition: 'right',
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'image-image-textOverlay':
      return {
        _id: utils.getNewObjectId(),
        type: 'image',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              image: {
                src: window.constants.imageUrl + 'blocks1/quote_background_image.jpg',
                // Need to change this placeholder image
                placeHolder:
                  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAA/ElEQVQYVwXBvSuEcQDA8e/Pc89dPSdPdKU7d/JMjxtQGCQTg/EWKauuDC4ZLIrJgMRAZolN3cCmlP/gJiV0d88iL8PzUM+L5+3n8xHWa0u2XtrI0COTy2JWhnhoe7ixguPH+EHE8kQR0T88Lq8vDynrOX7THk6bzxhGlZVJlYObJ2pTRdbWG4jS2JxMopSFpVUKZYPFisPZ7Rv12Qx7j3k+7o/wFQ0xMl2Tf5GPIkMaWxt0rQ5fssTd8SY79XlOmh0Cz0YMmjOyV9dJ45A+VUVkVbqWRQLk8wN4rotZsBEX59syQEPXBN+f75jVUXwvYXf/Cp+Yn1QjdWz+AZ+eYiHTnNK/AAAAAElFTkSuQmCC',
                thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                size: 100
              }
            },
            caption: '',
            paragraph:
              '<p><b>Dip your toes in the water. Laugh with us by the sea. Let your friends carry you on their good humor to the place where you ultimately belong.</b></p>'
          }
        ],
        family: 'image',
        variant: 'textOverlay',
        settings: {
          opacity: 0.4,
          paddingTop: 3,
          zoomOnClick: true,
          opacityColor: '#000000',
          paddingBottom: 3,
          backgroundColor: ''
        }
      };

    case 'multimedia-multimedia-audio':
      return {
        _id: utils.getNewObjectId(),
        type: 'multimedia',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              audio: {
                key: 'sample_audio.mp3',
                src:
                  'https://cdn.articulate.com/assets/rise/assets/block-defaults/sample_audio.mp3',
                duration: 178
              }
            },
            caption: ''
          }
        ],
        family: 'multimedia',
        variant: 'audio',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'multimedia-multimedia-video':
      return {
        _id: utils.getNewObjectId(),
        type: 'multimedia',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              video: {
                key: 'coastline.mp4',
                // 'src': window.constants.videoUrl + 'sample-video.mp4',
                src: 'wistiaId:mw5hioxuyy',
                poster: 'coastline_poster.png',
                thumbnail: window.constants.imageUrl + 'sample_video_thumb.jpg',
                duration: 25,
                meta: '{"allowSeekAhead":false}'
              }
            },
            caption: ''
          }
        ],
        family: 'multimedia',
        variant: 'video',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'multimedia-multimedia-embed':
      return {
        _id: utils.getNewObjectId(),
        type: 'multimedia',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              embed: {
                src:
                  '{"provider_url":"https://www.youtube.com/","description":"British Columbia, Canada\'s westernmost province, is an adventurer\'s paradise year-round. Journey along with National Geographic Adventurer Emily Harrington as she explores this epic landscape. ➡ Subscribe: http://bit.ly/NatGeoSubscribe About National Geographic: National Geographic is the world\'s premium destination for science, exploration, and adventure.","title":"Welcome to an Adventurer\'s Year-Round Paradise: British Columbia | National Geographic","url":"http://www.youtube.com/watch?v=2cleBlYbla8","author_name":"National Geographic","height":480,"thumbnail_width":480,"width":854,"html":"<iframe class=\\"embedly-embed\\" src=\\"//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2F2cleBlYbla8%3Ffeature%3Doembed&url=http%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D2cleBlYbla8&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2F2cleBlYbla8%2Fhqdefault.jpg&key=40fe86ee3b404724858baae1d097c574&type=text%2Fhtml&schema=youtube\\" width=\\"854\\" height=\\"480\\" scrolling=\\"no\\" frameborder=\\"0\\" allowfullscreen></iframe>","author_url":"https://www.youtube.com/user/NationalGeographic","version":"1.0","provider_name":"YouTube","thumbnail_url":"https://i.ytimg.com/vi/2cleBlYbla8/hqdefault.jpg","type":"video","thumbnail_height":360}',
                type: 'embedly'
              }
            }
          }
        ],
        family: 'multimedia',
        variant: 'embed',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'multimedia-multimedia-attachment':
      return {
        _id: utils.getNewObjectId(),
        type: 'multimedia',
        items: [
          {
            _id: utils.getNewObjectId(),
            media: {
              attachment: {
                src: 'https://s3.amazonaws.com/lyearn/assets/frontend-js/default.txt',
                fileSize: 45,
                fileName: 'default.txt'
              }
            }
          }
        ],
        family: 'multimedia',
        variant: 'attachment',
        settings: {
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'interactive-interactive-flashcardStack':
      return {
        _id: utils.getNewObjectId(),
        type: 'interactive',
        items: [
          {
            _id: utils.getNewObjectId(),
            back: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Back of card 1'
            },
            front: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Front of card 1'
            }
          },
          {
            _id: utils.getNewObjectId(),
            back: {
              type: 'fullimage',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Back of card 2'
            },
            front: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Front of card 2'
            }
          },
          {
            _id: utils.getNewObjectId(),
            back: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Back of card 3'
            },
            front: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Front of card 3'
            }
          }
        ],
        family: 'interactive',
        variant: 'flashcardStack',
        settings: {
          showHint: true,
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'interactive-interactive-flashcardGrid':
      return {
        _id: utils.getNewObjectId(),
        type: 'interactive',
        items: [
          {
            _id: utils.getNewObjectId(),
            back: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Back of card 1'
            },
            front: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Front of card 1'
            }
          },
          {
            _id: utils.getNewObjectId(),
            back: {
              type: 'fullimage',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Back of card 2'
            },
            front: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Front of card 2'
            }
          },
          {
            _id: utils.getNewObjectId(),
            back: {
              type: 'image',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Back of card 3'
            },
            front: {
              type: 'description',
              media: {
                image: {
                  key: 'assets/rise/assets/block-defaults/mountains.jpg',
                  src: window.constants.imageUrl + 'sample_image_file.jpg',
                  type: 'image',
                  thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
                  originalUrl: 'mountains.jpg'
                }
              },
              description: 'Front of card 3'
            }
          }
        ],
        family: 'interactive',
        variant: 'flashcardGrid',
        settings: {
          showHint: true,
          paddingTop: 3,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'interactive-interactive-accordion':
      return {
        _id: utils.getNewObjectId(),
        type: 'interactive',
        items: [
          {
            _id: utils.getNewObjectId(),
            heading: 'Title 1',
            html:
              "<p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
          },
          {
            _id: utils.getNewObjectId(),
            heading: 'Title 2',
            html:
              "<p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
          },
          {
            _id: utils.getNewObjectId(),
            heading: 'Title 3',
            html:
              "<p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
          }
        ],
        family: 'interactive',
        variant: 'accordion',
        settings: {
          paddingTop: 3,
          zoomOnClick: true,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    case 'interactive-interactive-tabs':
      return {
        _id: utils.getNewObjectId(),
        type: 'interactive',
        items: [
          {
            _id: utils.getNewObjectId(),
            heading: 'Title 1',
            html:
              "<p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
          },
          {
            _id: utils.getNewObjectId(),
            heading: 'Gaining Insight',
            html:
              "<p>To spark creativity, feed your brain material like you're cramming for a tough test.\n      Then stop thinking about the problem you want to solve. Go surfing or take a leisurely walk.\n      Research shows that letting your mind wander fosters creativity.</p><br>\n      <p>It’s also found that meditation helps you spot and solve problems in creative ways. It promotes\n      divergent thinking that gets novel ideas flowing. According to these studies, meditation also makes\n      you more open to considering new solutions. Time to breathe.</p>"
          },
          {
            _id: utils.getNewObjectId(),
            heading: 'Making It Real',
            html:
              '<p>No creative process is truly complete until it manifests a tangible reality. Whether your\n      idea is an action or a physical creation, bringing it to life will likely involve the hard work of\n      iteration, testing, and refinement.</p><br>\n      <p>Just be wary of perfectionism. Push yourself to share your creations with others. By maintaining an\n      open stance, you’ll be able to learn from their feedback. Consider their responses new material that you\n      can draw from the next time you’re embarking on a creative endeavor.</p>'
          }
        ],
        family: 'interactive',
        variant: 'tabs',
        settings: {
          paddingTop: 3,
          zoomOnClick: true,
          paddingBottom: 3,
          backgroundColor: '',
          entranceAnimation: true
        }
      };
    default:
      return {};
  }
}
